<main>
  @if (showUnavailMessage && !showLookup) {
    <h6 style="margin-top: 30px; margin-bottom: 30px; text-align: center">
      This feature has not been enabled for you library
    </h6>
  }

  @if (loading && showLookup) {
    <div
      class="text-center"
      style="width: 100%; position: relative; height: 250px; vertical-align: middle; top: 45%"
    >
      <mat-spinner
        style="display: inline-block; position: relative; margin-top: 5em"
        diameter="24"
      ></mat-spinner>
    </div>
  }

  @if (!loading && showLookup) {
    <div>
      <div class="login-background">
        <div
          class="login-form col-12 col-sm-10 col-md-8 col-lg-6 offset-sm-1 offset-md-2 offset-lg-3"
        >
          <div class="card login-card">
            <div id="tabs-container">
              <img src="./assets/images/patron-lookup-demo.png" alt="patron lookup image" />
            </div>
            @if (cid) {
              <div class="card-block">
                @if (cid !== 'rail') {
                  <h6 style="margin-bottom: 30px">{{ instructionalText1 }}</h6>
                }
                @if (cid === 'rail') {
                  <div style="margin-bottom: 30px">
                    <h6>
                      Staff at participating libraries can use this tool to check the status of
                      reciprocal borrowers at their home library. Login with the credentials
                      provided by FMI staff, or contact
                      <a href="mailto:support@findmoreillinois.org"
                        >support&#64;findmoreillinois.org</a
                      >
                      for help.
                    </h6>
                  </div>
                }
                <form #loginForm class="form-horizontal" autocomplete="off" [formGroup]="login">
                  <div id="lib-dropdown">
                    <mat-form-field style="width: 100%" class="clearfix">
                      <input
                        id="searchBox"
                        type="text"
                        [placeholder]="cid !== 'rail' ? libraryDropText1 : libraryDropText2"
                        title="Choose Library"
                        matInput
                        [formControl]="filterLibrary"
                        [(ngModel)]="LIB"
                        [matAutocomplete]="auto"
                      /><i
                        class="fa fa-chevron-down d-inline-block pointer"
                        aria-hidden="true"
                        (click)="showLibList()"
                      ></i>
                      <mat-autocomplete #auto="matAutocomplete">
                        @if (libraries) {
                          <div>
                            @for (library of libraries; track library; let i = $index) {
                              <mat-option
                                value="{{ library.lid }}:{{ library.name }}"
                                innerHTML="{{ library.lid }}:{{ library.name }}"
                              >
                              </mat-option>
                            }
                          </div>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>
                  <!-- User and Password -->
                  <mat-form-field style="width: 100%" class="clearfix">
                    <!-- eslint-disable @angular-eslint/template/no-autofocus -->
                    <input
                      #userField
                      autofocus
                      type="text"
                      matInput
                      formControlName="user"
                      autocomplete="nope"
                      [placeholder]="cid !== 'rail' ? userNameText1 : userNameText2"
                      [title]="cid !== 'rail' ? userNameText1 : userNameText2"
                    />
                  </mat-form-field>
                  <mat-form-field style="width: 100%" class="clearfix">
                    <input
                      type="password"
                      matInput
                      formControlName="password"
                      autocomplete="nope-again"
                      [placeholder]="cid !== 'rail' ? passwordText1 : passwordText2"
                      [title]="cid !== 'rail' ? passwordText1 : passwordText2"
                    />
                  </mat-form-field>
                  <div class="text-end clearfix">
                    <button
                      role="button"
                      type="button"
                      aria-label="Submit"
                      class="btn btn-primary"
                      [disabled]="!login.valid"
                      (click)="loginSubmit()"
                      (keyup.enter)="loginSubmit()"
                    >
                      @if (!btnLoading) {
                        <span style="width: 175px">Submit</span>
                      }
                      @if (btnLoading) {
                        <span style="width: 175px">
                          <i class="fa fa-spinner fa-pulse fa-fw"></i>
                        </span>
                      }
                    </button>
                  </div>
                </form>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
</main>
